import React from 'react';
import { styled, css } from 'styled-components';
import { Viewports } from '../../../../play-core/styles/Viewports';
import { jsx as _jsx } from "react/jsx-runtime";
export const defaultConfig = [['small', {
  itemCount: 1,
  verticalSpacing: 20,
  horizontalSpacing: 8
}], ['medium', {
  itemCount: 3,
  verticalSpacing: 40,
  horizontalSpacing: 16
}], ['large', {
  itemCount: 3,
  verticalSpacing: 40,
  horizontalSpacing: 16
}], ['xLargeUp', {
  itemCount: 4,
  verticalSpacing: 40,
  horizontalSpacing: 16
}]];
export const GridView = ({
  children,
  config = defaultConfig
}) => /*#__PURE__*/_jsx(Layout, {
  config: config,
  children: children
});
export const Layout = styled.div.withConfig({
  displayName: "GridView__Layout",
  componentId: "sc-1sywot3-0"
})(["display:grid;", ";"], props => calculateLayout(props.config));
const calculateLayout = config => config.map(([viewport, value]) => css(["", "{grid-template-columns:repeat(", ",minmax(0,1fr));grid-row-gap:", "px;grid-column-gap:", "px;}"], Viewports.for(viewport), value.itemCount, value.verticalSpacing, value.horizontalSpacing));